// NX-6284: Ireland "8% of worked hours (irregular)" holiday pay.
import type {
  GetIrregularHolidayTimesheetViewResponse,
  GetIrregularHolidayWorkerSummaryResponse,
  IrregularHolidayTimesheetViewParams,
  UpdateIrregularHolidayOpeningBalancesParams,
  UpdateIrregularHolidayOpeningBalancesResponse,
} from '@nxsys/types/api';
import axios from '../axios';
import { endPoints } from '../endpoints';

// `workedHours` is passed for a leaver (P45) timesheet so the suggestion
// includes hours worked in the final, not-yet-confirmed period — those
// otherwise aren't reflected in the balance until that payroll is confirmed.
//
// Payroll-settings-gated (opening balances, leave-year hours) — used by the
// worker dashboard and the worker settings screen, where the signed-in user
// already holds that permission to view the page at all.
export const getIrregularHolidayWorkerSummaryApi = async (
  id: string,
  workedHours?: number,
): Promise<GetIrregularHolidayWorkerSummaryResponse> => {
  const response = await axios.get(
    endPoints.irregularHoliday.workerSummary(id),
    { params: workedHours != null ? { workedHours } : undefined },
  );
  return response.data;
};

// `timesheets:create`-gated, not payroll-settings — the one TimesheetForm/
// AppRateForm call, since adding/editing a timesheet is reachable by an
// agency contact or a company user who only holds the Timesheets screen,
// neither of whom can call GET /workers/:id.
export const getIrregularHolidayTimesheetViewApi = async (
  id: string,
  params: IrregularHolidayTimesheetViewParams = {},
): Promise<GetIrregularHolidayTimesheetViewResponse> => {
  const response = await axios.get(
    endPoints.irregularHoliday.timesheetView(id),
    {
      // Unset fields are left out rather than sent empty.
      params: Object.fromEntries(
        Object.entries(params).filter(([, v]) => v != null),
      ),
    },
  );
  return response.data;
};

export const updateIrregularHolidayOpeningBalancesApi = async (
  id: string,
  params: UpdateIrregularHolidayOpeningBalancesParams,
): Promise<UpdateIrregularHolidayOpeningBalancesResponse> => {
  const response = await axios.put(
    endPoints.irregularHoliday.openingBalances(id),
    params,
  );
  return response.data;
};
